import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Select } from 'primeng/select';
import { Country } from '../../../core/models/common/countries.model';
import { Phone } from '../../../core/models/common/phone.model';
import { INPUT_TYPES } from '../../constants/input-types';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  selector: 'app-input-form',
  templateUrl: './input-form.component.html',
  styleUrl: './input-form.component.scss',
  standalone: false
})
export class InputFormComponent<T, V = T> implements OnInit {
  @ViewChild('selectRef') selectRef!: Select;
  @Output() search = new EventEmitter<string>();

  @Input() showTime = false;
  @Input() hourFormat = '12';

  INPUT_TYPES = INPUT_TYPES;

  @Input() readOnly = false;
  @Input() disabledPhoneCode = false;
  @Input() icon: string | undefined = 'pi pi-user';
  @Input() placeholder = '';
  @Input() suggestions: string[] = [];
  @Input() type = 'text';
  @Output() valueChange = new EventEmitter<T | null>();
  @Input() completeMethod: (event: AutoCompleteCompleteEvent) => void = () => { };
  @Input() filterSelected = false;

  // @Input() selectedCountry = '';
  @Input() value: string | null = null;
  @Input() valueObject: T | null = null;
  @Input() lazy = false;

  private _selectedCountry: string | null = null;
  private _listCountries: Country[] = [];

  private _internalCurrentPhone = '';//numero de telefono sin codigo de pais que entrar para editar
  @Input() set currentPhone(val: string | null) {
    this._internalCurrentPhone = val ?? '';
    if (this.value === null || this.value === '') {
      this.value = this._internalCurrentPhone;
    }
  }
  get currentPhone(): string | null {
    return this._internalCurrentPhone;
  }


  @Input()
  set selectedCountry(val: string | null) {
    this._selectedCountry = val;
    this.resolveSelectedCountry();
  }
  get selectedCountry(): string | null {
    return this._selectedCountry;
  }

  private _list: { name: string; value: string }[] = [];

  @Input() optionMapper?: (item: V) => { name: string; value: string };

  @Input()
  set list(value: V[]) {
    if (!value) {
      this._list = [];
      return;
    }
    if (this.optionMapper) {
      this._list = value.map(this.optionMapper);
    } else if (typeof value[0] === 'string') {
      this._list = (value as unknown as string[]).map(item => ({ name: item, value: item }));
    } else if (value[0] != null && typeof value[0] === 'object' && 'name' in value[0] && 'value' in value[0]) {
      this._list = value as unknown as { name: string; value: string }[];
    } else {
      this._list = value.map(item => ({ name: String(item), value: String(item) }));
    }
  }

  get list(): { name: string; value: string }[] {
    return this._list;
  }

  @Input()
  set listCountries(value: Country[]) {
    this._listCountries = value;
    this.resolveSelectedCountry();
  }
  get listCountries(): Country[] {
    return this._listCountries;
  }

  private resolveSelectedCountry() {
    if (!this._listCountries || this._listCountries.length === 0) return;
    let val = this._selectedCountry ?? '';
    if (val.startsWith('+')) {
      val = val.slice(1);
    }

    if (!val) {
      this._selectedCountry = this._listCountries[0].code;
      return;
    }

    if (/^\d+$/.test(val)) {
      const found = this._listCountries.find(c => String(c.dialCode) === val);
      this._selectedCountry = found ? found.code : this._listCountries[0].code;
    }

    else if (this._listCountries.some(c => c.code === val)) {
      this._selectedCountry = val;
    }

    else {
      this._selectedCountry = this._listCountries[0].code;
    }
  }

  constructor() {

  }

  onSelectShow() {
    //TODO: Implement multi-select behavior for lazy loading
    if (this.lazy) {
      setTimeout(() => {
        const input = this.selectRef?.el?.nativeElement.querySelector('input');
        if (input) {
          input.addEventListener('input', (event: Event) => {
            const target = event.target as HTMLInputElement;
            this.search.emit(target.value);
          });
        }
      }, 0);
    }
  }

  ngOnInit() {
    if (this.listCountries && this.listCountries.length > 0 && this.selectedCountry === null) {
      this.selectedCountry = this.listCountries[0].code;
    }
  }

  getDialCode(code: string): string {
    const dialCode = this.listCountries.find(c => c.code === code)?.dialCode;
    return dialCode !== undefined ? String(dialCode) : '';
  }

  // onCountryChange(event: any) {
  //   this.selectedCountry = event.target.value;
  // }

  emitPhoneValue() {
    let number = (this.value || '').replace(/-/g, '');
    let phone = new Phone('+' + this.getDialCode(this.selectedCountry ?? ''), number);
    this.valueChange.emit(phone as T);
  }
  savePhoneValue($event: string) {
    this.value = $event;
    this.emitPhoneValue();
  }
  saveCountryCode($event: string) {
    this.selectedCountry = $event;
    this.emitPhoneValue();
  }

  onSelectChange(val: T) {
    this.valueChange.emit(val);
  }

  onPickedDate($event: T) {
    this.valueChange.emit($event as T);
  }

  onInputChange($event: unknown) {
    this.valueChange.emit($event as T);
  }

  onPlateChange(value: string) {
  const filtered = (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (filtered !== value) {
    this.value = filtered;
    this.valueChange.emit(filtered as T);
  } else {
    this.value = filtered;
    this.valueChange.emit(filtered as T);
  }
}

onPlateInput(event: Event) {
  const input = event.target as HTMLInputElement;
  const filtered = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (filtered !== input.value) {
    input.value = filtered;
    this.value = filtered;
    this.valueChange.emit(filtered as T);
  }
}

onPlateKeyDown(event: KeyboardEvent) {
  if (
    event.key.length === 1 &&
    !/[A-Z0-9]/i.test(event.key)
  ) {
    event.preventDefault();
  }
}
}